import { create } from "zustand";

const initialState = {
  showLoadingModal: false,
};

const useMiscUIStore = create((set) => ({
  ...initialState,
  setShowLoadingModal: (payload) => {
    set({ showLoadingModal: payload });
  },
}));

export default useMiscUIStore;
